import { _errMissing, _errUnexpected } from "@/app/errors"
import { Term } from "@/app/types"

export function _errMissingEntity(isFund: boolean, ctx: Object) {
  return _errMissing("ERR-GC-01", isFund ? "fund" : "firm", { entity: ctx })
}

export function errMissingCategory(ctx: Object) {
  return _errMissing("ERR-GC-02", "category data", ctx)
}
export function errMissingEntityMetrics(isFund: boolean, ctx: Object) {
  return _errMissing("ERR-GC-03", isFund ? "fund metrics" : "firm metrics", ctx)
}
export function errMissingCategoryMetrics(ctx: Object) {
  return _errMissing("ERR-GC-04", "category metrics", ctx)
}

export function errMissingIndustryMetrics(ctx: Object) {
  return _errMissing("ERR-GC-05", "industry metrics", ctx)
}

export function errMissingTerm(ctx: Object) {
  return _errMissing("ERR-GC-06", "term in META terms API", ctx)
}

export function errMissingSet(setProperty: string, ctx: Object) {
  return _errMissing("ERR-GC-07", { propertyname: setProperty }, ctx)
}

export function errMissingPeers(ctx: Object) {
  return _errMissing("ERR-GC-08", "peers", ctx)
}

export function errMissingFunc(func: string, ctx: Object) {
  return _errMissing("ERR-GC-09", `${func} in peers`, ctx)
}

export function errMissingTop10(ctx: Object) {
  return _errMissing("ERR-GC-10", "top10 metrics data", ctx)
}

export function errMissingMetric(metricName: string, ctx: Object) {
  return errMissingMetrics([metricName], ctx)
}

export function errMissingMetrics(metricNames: string[], ctx: Object) {
  return _errMissing("ERR-GC-11", metricNames, ctx)
}

export function errInvalidSeries(
  expectedLen: number,
  comparisonGroup: string,
  len: number,
  ctx: Object
) {
  return _errUnexpected(
    "ERR-GC-12",
    "series length for the group of",
    expectedLen,
    len,
    ctx,
    comparisonGroup
  )
}

export function errMissingKeySeries(expectedKey: string, ctx: Object) {
  return _errMissing("ERR-GC-13", `ranking key ${expectedKey}`, ctx)
}

export function errMismatchedEndIdx(
  expectedEndIdx: number,
  comparisonGroup: string,
  gotEndIdx: number,
  ctx: Object
) {
  return _errUnexpected(
    "ERR-GC-14",
    "endIdx",
    expectedEndIdx,
    gotEndIdx,
    ctx,
    comparisonGroup
  )
}

export function errMissingComparisonGroup(ctx: Object) {
  return _errMissing("ERR-GC-15", "one or more comparison group", ctx)
}

export function errMissingChartMetric(ctx: Object) {
  return _errMissing("ERR-GC-16", "metric name", ctx)
}

export function errMissingMembers(ctx: Object) {
  return _errMissing("ERR-GC-17", "members", ctx)
}

export function errMissingChartType(chartType: string, ctx: Object) {
  return _errMissing("ERR-GC-18", `${chartType} chart data`, ctx)
}

export function errMissingTermKeyInValues(
  isPeriodic: boolean,
  term: Term,
  termInterval: string,
  termKey: string,
  ctx: Object
) {
  return _errMissing(
    "ERR-GC-19",
    `term key: ${termKey} for the selected term interval: ${termInterval} of the term: ${term} in ${isPeriodic ? "Periodic" : "Ranking"} values`,
    ctx
  )
}
